import React from 'react';
import yahooFantasyWordmark from '../assets/yahoo-fantasy-wordmark.svg';
import { YAHOO_ATTRIBUTION_TEXT, YAHOO_ATTRIBUTION_URL } from '../utils/providerPolicy';

/**
 * Licence-required attribution for pages that display Yahoo Fantasy data.
 *
 * Must stay as supplied: the official Yahoo Fantasy wordmark, unmodified
 * (yahoo-fantasy-wordmark.svg is the supplied file with only its transparent
 * padding trimmed), and the text "Fantasy data provided by Yahoo Fantasy"
 * linking to an official Yahoo Fantasy page.  Do not recolor, distort, or
 * combine the mark with other logos.
 */
const YahooAttribution = ({ className = '' }) => (
  <a
    href={YAHOO_ATTRIBUTION_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="yahoo-attribution"
    className={`inline-flex items-center gap-2 text-text-muted text-xs font-semibold hover:text-text transition-colors ${className}`}
  >
    <img
      src={yahooFantasyWordmark}
      alt="Yahoo Fantasy"
      height={16}
      className="h-4 w-auto shrink-0"
    />
    <span>{YAHOO_ATTRIBUTION_TEXT}</span>
  </a>
);

export default YahooAttribution;
